import { Head, Link } from '@inertiajs/react'
import Form from './form.tsx'
import type { AreaAgentOptionType, AreaType, CommunityOptionType } from './types.ts'
import {ArrowLeft} from "lucide-react";

interface NewProps {
  area: AreaType
  agents?: AreaAgentOptionType[]
  communities?: CommunityOptionType[]
  can_select_community?: boolean
}

export default function New({ area, agents = [], communities = [], can_select_community = false }: NewProps) {
  return (
    <>
      <Head title="Nouvelle zone" />

        <div className="flex flex-col gap-6 p-8">
            {/* Header */}
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <Link href="/admin/areas">
                        <button className="rounded-lg border border-border p-2 text-foreground hover:bg-secondary transition-colors">
                            <ArrowLeft className="h-5 w-5" />
                        </button>
                    </Link>
                    <div>
                        <h1 className="text-3xl font-bold text-foreground">Créer une zone</h1>
                        <p className="text-sm text-muted-foreground">Ajouter une nouvelle zone de collete</p>
                    </div>
                </div>
            </div>

        <Form
          area={area}
          agents={agents}
          communities={communities}
          can_select_community={can_select_community}
          method="post"
          action="/admin/areas"
          submitText="Créer une zone"
        />

        <Link
          href="/areas"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Retour aux zones
        </Link>
      </div>
    </>
  )
}
